import { Component, inject } from '@angular/core';
import { MatterNotesDispatch } from '@state/matter/notes';
import { ButtonComponent } from '@ui/button/button.component';
import { MODAL_DATA } from '@ui/modal/modal-data.token';
import { ModalService } from '@ui/modal/modal.service';

@Component({
	selector: 'app-delete-note-confirmation',
	templateUrl: './delete-note-confirmation.component.html',
	standalone: true,
	imports: [ButtonComponent],
})
export class DeleteNoteConfirmationComponent {
	private modalService = inject(ModalService);
	private noteDispatch = inject(MatterNotesDispatch);
	private modalData = inject(MODAL_DATA);

	onDelete(): void {
		this.noteDispatch.Remove(this.modalData.noteId);
		this.modalService.closeModal();
	}

	onCancel(): void {
		this.modalService.closeModal();
	}
}
